import { AlertTriangle } from "lucide-react";
import { createPortal } from "react-dom";

export const ConfirmDialog = ({ open, title, description, confirmLabel = "Supprimer", busy = false, onConfirm, onCancel }) => {
  if (!open) return null;
  return createPortal(
    <div className="confirm-backdrop" onClick={busy ? undefined : onCancel} data-testid="confirm-dialog-backdrop">
      <div className="confirm-dialog" role="dialog" aria-modal="true" onClick={(event) => event.stopPropagation()} data-testid="confirm-dialog">
        <div className="confirm-icon"><AlertTriangle size={20} /></div>
        <h3 data-testid="confirm-dialog-title">{title}</h3>
        <p data-testid="confirm-dialog-description">{description}</p>
        <div className="confirm-actions">
          <button type="button" className="secondary-button" onClick={onCancel} disabled={busy} data-testid="confirm-dialog-cancel">Annuler</button>
          <button type="button" className="danger-button" onClick={onConfirm} disabled={busy} data-testid="confirm-dialog-confirm">
            {busy ? "Suppression…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};
